module.exports = __webpack_public_path__ + "img/tiktok-money.7f3b59ac.webp";